import SailsService from './sails.service';

/* @ngInject */
export default class OrganizationService extends SailsService {
  constructor() {
    super('organization');
    this.store = super.model();

    this.create = super.post;
    this.get = super.get;
    this.update = super.put;
  }

  /**
   * Model reference
   * This should *ALWAYS* be awaited, in case a `get` is needed
   *
   * @readonly
   * @memberof OrganizationService
   * @returns {object | Promise<object>}
   */
  get model() {
    return _.isEmpty(this.store.byId) ?
      this.get().then(() => this.store) :
      this.store;
  }

  getOrgsManagedByOrg(orgId) {
    return this.get([orgId, 'managed']);
  }

  destroy(id) {
    return super.delete(id);
  }

  licenses(id) {
    return this.get([id, 'license', 'summary']);
  }

  license(id, { qty: howMany, licenseType }) {
    return super.post([id, 'license'], { howMany, licenseType });
  }
}
